








import { Vue, Component } from 'vue-property-decorator';
import SyForm from '@/components/SyForm/SyForm.vue';
import generateConfig from '@/components/SyForm/FormConfig';
import FormSearchInput from '@/components/SyForm/FormSearchInput.vue';
@Component({
  components: {
    SyForm,
    FormSearchInput,
  },
})
export default class FormList extends Vue {
  config = generateConfig();

  getData(data: any) {
    console.log(data);
  }
}
